<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :applyTranslate="false"
              :isRequiredFarms="true"
              :onlyFarmsFruits="true"
              :filterOfLots="false"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-sm-6"
            >
              <template slot="prev">
                <select-component
                  :dataOptions="optionsFilter"
                  :initialSelection="optionSel"
                  @onChange="handleChangeSelected"
                  :labelSelect="`${$t('common_words.report_typeof')}: *`"
                  modelName="optionSel"
                  requireClass="required-options"
                  rowClass="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 pt-3"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <template v-if="tableData['byLots'] && tableData['byLots'].length > 0">
        <br />
        <report-by-lots
          :farmList="tableData['byLots'][0].farms"
          :dataFarm="farmData['byLots']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template v-if="tableData['byTotal'] && tableData['byTotal'].length > 0">
        <br />
        <report-by-totals
          :farmList="tableData['byTotal'][0].farms"
          :dataFarm="farmData['byTotal']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="tableData['byTotalHa'] && tableData['byTotalHa'].length > 0"
      >
        <br />
        <report-by-total-has
          :farmList="tableData['byTotalHa'][0].farms"
          :dataFarm="farmData['byTotalHa']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="tableData['byLotsHa'] && tableData['byLotsHa'].length > 0"
      >
        <br />
        <report-by-lots
          :farmList="tableData['byLotsHa'][0].farms"
          :dataFarm="farmData['byLotsHa']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
          option="byLotsHa"
        />
      </template>
      <template
        v-if="
          tableData['byLotsPercent'] && tableData['byLotsPercent'].length > 0
        "
      >
        <br />
        <report-percent-by-lots
          :farmList="tableData['byLotsPercent'][0].farms"
          :dataFarm="farmData['byLotsPercent']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
          option="byLotsPercent"
        />
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import Filter from 'src/components/Filter/Filters.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import ReportByLots from './ReportByLots.vue';
import ReportPercentByLots from './ReportPercentByLots.vue';
import ReportByTotals from './ReportByTotals.vue';
import ReportByTotalHas from './ReportByTotalHas.vue';
import Select from 'src/components/Selects/Select.vue';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [Filter.name]: Filter,
    [ReportByLots.name]: ReportByLots,
    [ReportByTotalHas.name]: ReportByTotalHas,
    [ReportByTotals.name]: ReportByTotals,
    [ReportPercentByLots.name]: ReportPercentByLots,
    [Select.name]: Select,
  },

  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    optionsFilter() {
      return this.concatAll([
        {
          id: 1,
          name: i18n.t('production.bagged_by_allotments'),
          option: 'byLots',
          file: 'reporte_embolse_por_lotes',
          notFoundMessage: i18n.t('message.production.not_found_bagged'),
        },
        {
          id: 2,
          name: i18n.t('production.total_bagged'),
          option: 'byTotal',
          file: 'reporte_embolse_total',
          notFoundMessage: i18n.t('message.production.not_found_bagged'),
        },
        {
          id: 3,
          name: i18n.t('production.bunched_bagged_per_hectare'),
          option: 'byTotalHa',
          file: 'reporte_embolse_total_has',
          notFoundMessage: i18n.t('message.production.not_found_bagged'),
        },
        {
          id: 4,
          name: i18n.t('production.bunched_bagged_per_lot'),
          option: 'byLotsHa',
          file: 'reporte_embolse_por_lotes_has',
          notFoundMessage: i18n.t('message.production.not_found_bagged'),
        },
        {
          id: 5,
          name: i18n.t('production.percentage_bunched_bagged_per_lot'),
          option: 'byLotsPercent',
          file: 'reporte_embolse_percent_lotes',
          notFoundMessage: i18n.t('message.production.not_found_bagged'),
        },
      ]);
    },
  },

  data() {
    return {
      activeName: 'filter',
      optionSel: [],
      valueCollapse: null,
      tableData: {
        byLots: [],
      },
      farmData: [],
      totalArea: [],
    };
  },

  mixins: [MixinExport, MixinMasters, MixinMenu],

  methods: {
    handleChangeSelected(data) {
      this.optionSel = [...data.selects];
    },

    handleChangeMenuSelected(data) {
      const selected = { ...this.tableData[data.option][0] };
      const dataSelected = [];
      dataSelected['farm'] = data.id;
      Object.keys(selected).forEach((key) => {
        dataSelected[key] = selected[key][data.id];
      });
      this.$set(this.farmData, data.option, dataSelected);
    },

    handleFilter(data) {
      this.dataFilter = { ...data };
      if (this.optionSel.length == 0)
        return this.validationInputsRequired('options');
      else this.loadReport();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    loadReport() {
      this.showHideLoading(true);
      this.tableData = {
        byLots: [],
      };
      this.dataFilter.route = 'pockets/advancedreport';
      this.dataFilter.optionSel = this.optionSel;

      Axios.postMasters(this.dataFilter)
        .then((response) => {
          this.optionSel.forEach((sel) => {
            const optionFilter = this.optionsFilter.find(
              (option) => option.id == sel
            );
            const dataResponse = response.data.data.find(
              (result) => result[optionFilter.option]
            );
            if (
              Object.keys(dataResponse[optionFilter.option].totalColumns)
                .length == 0
            ) {
              SweetAlert.warning(optionFilter.notFoundMessage);
              this.$set(this.tableData, optionFilter.option, []);
            } else {
              this.$set(this.tableData, optionFilter.option, [
                dataResponse[optionFilter.option],
              ]);
            }
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    exportToExcel(data) {
      const optionFilter = this.optionsFilter.find(
        (option) => option.id === data.optionBackend
      );
      this.Excel(
        {
          route: 'pockets/advancedreport/excel',
          name_file: `${optionFilter.file}.xlsx`,
          farm: [this.farmData[data.optionFront]['farm']],
          bySel: this.dataFilter.bySel,
          datei: this.dataFilter.datei,
          datef: this.dataFilter.datef,
          optionSel: [data.optionBackend],
          typeReport: [data.optionFront],
        },
        'POST',
        true
      )
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },
  },

  mounted() {
    this.selectedItemOnMenu('pockets');
  },

  destroyed() {
    this.deselectedItemOnMenu('pockets');
  },
};
</script>
<style>
.card .table:not(.not-last-td) tbody td:last-child,
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}
</style>
